import React from 'react';
import { useAppSelector } from 'store/hooks';
import { useNavigate } from 'react-router-dom';

import { userSelector } from 'store/auth/selectors';

import NotFoundPage from './NotFoundPage';

const NotFoundPageContainer = () => {
  const navigate = useNavigate();

  const user = useAppSelector(userSelector);

  const handleButtonClick = () => {
    navigate(user ? '/dashboard' : '/');
  };

  return <NotFoundPage onButtonClick={handleButtonClick} />;
};

export default React.memo(NotFoundPageContainer) as any;
